import React from 'react';
import bstyles from '../branches/BranchIdentityStrip.module.css';
import styles from './ReleaseIdentityStrip.module.css';
import Pill from '../common/Pill';
import Ico from '../common/Ico';
import ActorCell from '../branches/ActorCell';
import ActionsForReleaseDetail from './ActionsForReleaseDetail';
import { statusLabel } from '../branches/statusConfig';
import { timeSinceTS } from '../../helpers/dates';

const ICO_ROCKET   = 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z';
const ICO_CHEVLEFT = 'm15 18-6-6 6-6';
const ICO_CLOCK    = 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM12 7v5l3 2';
const ICO_TAG      = 'M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01';

export default function ReleaseIdentityStrip({ release, reloadData, navigate }) {
  return (
    <div className={bstyles.strip}>
      <div className={bstyles.inner}>
        <div className={bstyles.row}>
          <div className={bstyles.avatar}>
            <Ico d={ICO_ROCKET} size={24} style={{ color: '#fff' }} strokeWidth={1.7} />
          </div>

          <div className={bstyles.identity}>
            <div className={bstyles.nameRow}>
              <h1 className={bstyles.name}>
                Release <span className={bstyles.version}>{release.version}</span>
              </h1>
              {release.status && (
                <Pill status={release.status} dot>
                  {statusLabel(release.status)}
                </Pill>
              )}
              {release.is_latest && (
                <span className={styles.latestBadge}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                    <path d="m12 2 2.9 6.26L22 9.27l-5 4.87 1.18 6.86L12 17.77l-6.18 3.23L7 14.14 2 9.27l7.1-1.01L12 2z" />
                  </svg>
                  Latest release
                </span>
              )}
              {release.branch_version && (
                <button
                  type="button"
                  className={styles.branchChip}
                  onClick={() => navigate(`/branches/${release.branch_version}`)}
                >
                  <Ico d={ICO_CHEVLEFT} size={11} strokeWidth={2} />
                  cut from branch&nbsp;<span className={styles.branchChipVersion}>{release.branch_version}</span>
                </button>
              )}
            </div>

            <div className={bstyles.meta}>
              <span className={bstyles.metaItem}>
                <span className={bstyles.metaLabel}>Triggered by</span>
                <ActorCell actor={release.triggered_by} />
              </span>

              {release.created && (
                <>
                  <span className={bstyles.dot}>·</span>
                  <span className={bstyles.metaItem}>
                    <Ico d={ICO_CLOCK} size={14} style={{ color: 'var(--fg-muted)' }} />
                    <span className={bstyles.metaLabel}>Created</span>
                    <strong className={bstyles.metaStrong}>{timeSinceTS(release.created)}</strong>
                  </span>
                </>
              )}

              {release.to_release && (
                <>
                  <span className={bstyles.dot}>·</span>
                  <span className={styles.toReleaseBadge}>
                    <Ico d={ICO_TAG} size={10} strokeWidth={2.4} />
                    To-release target
                  </span>
                </>
              )}
            </div>
          </div>

          <div className={bstyles.actions}>
            <ActionsForReleaseDetail release={release} reloadData={reloadData} navigate={navigate} />
          </div>
        </div>
      </div>
    </div>
  );
}
